export default __webpack_public_path__ + "static/media/640_dummy2016-yoga02-de.3d29c77f.png";